<template>
  <div
    :id="'screen'"
    :style="{opacity: opacity}"
  >
    <Background />

    <main class="scrollable container">
      <h2 :style="{marginBottom: '20px'}">Notifications</h2>
      <ul>
        <li
          v-for="(notification, index) in notifications"
          :key="notification.id"
          :style="{
            padding: '20px',
            borderRadius: '10px',
            marginBottom: index === notifications.length - 1 ? '0' : '10px',
            border: '1px solid #FFEFE6',
            backgroundColor: 'var(--white-color)',
          }"
        >
          <div
            class="row-center"
            :style="{gap: '8px', marginBottom: '14px'}"
          >
            <component :is="notification.icon" />
            <h5 class="number-of-lines-1">
              {{ notification.title }}
            </h5>
          </div>
          <p
            class="t16"
            :style="{marginBottom: '14px'}"
            v-if="notification.description"
          >
            {{ notification.description }}
          </p>
          <span class="t12">{{ notification.date }}</span>
        </li>
      </ul>
    </main>
  </div>
</template>

<script setup>
import {useOpacity} from '@/hooks';
import {Background} from '@/components';
import {AlertSvg} from '@/assets/svg';
import {Rejected} from '@/assets/svg';
import {NotificationCheckSvg} from '@/assets/svg';

const opacity = useOpacity();

const notifications = [
  {
    id: 1,
    title: 'Your loan application has been approved!',
    date: 'Apr 12, 2023 at 12:47 PM',
    icon: NotificationCheckSvg,
  },
  {
    id: 2,
    title: 'Your loan application was rejected!',
    description:
      'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    date: 'Apr 12, 2023 at 12:47 PM',
    icon: AlertSvg,
  },
  {
    id: 3,
    title: 'The loan repayment period expires!',
    description:
      'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
    date: 'Apr 12, 2023 at 12:47 PM',
    icon: Rejected,
  },
  {
    id: 4,
    title: 'Your piggy bank is full!',
    date: 'Apr 12, 2023 at 12:47 PM',
    icon: NotificationCheckSvg,
  },
];
</script>
